import React, { useEffect, useState } from 'react';

const ToastNotification = ({ message, type = 'info', duration = 3000, onClose }) => {
  const [isVisible, setIsVisible] = useState(true);

  useEffect(() => {
    const timer = setTimeout(() => {
      setIsVisible(false);
      setTimeout(onClose, 300); // Allow fade out animation
    }, duration);

    return () => clearTimeout(timer);
  }, [duration, onClose]);

  const getTypeStyles = () => {
    switch (type) {
      case 'success':
        return 'bg-green-500 text-white border-green-400';
      case 'info':
        return 'bg-blue-500 text-white border-blue-400';
      case 'warning':
        return 'bg-yellow-500 text-white border-yellow-400';
      case 'error':
        return 'bg-red-500 text-white border-red-400';
      default:
        return 'bg-gray-500 text-white border-gray-400';
    }
  };

  return (
    <div
      className={`
        fixed bottom-4 left-1/2 transform -translate-x-1/2 z-50 max-w-sm w-full mx-4
        px-4 py-3 rounded-lg shadow-lg border-l-4
        transition-all duration-300 ease-in-out
        ${isVisible ? 'translate-y-0 opacity-100' : 'translate-y-full opacity-0'}
        ${getTypeStyles()}
      `}
    >
      <div className="flex items-center justify-between">
        <div className="flex items-center space-x-2">
          <div className="text-sm font-medium">{message}</div>
        </div>
        <button
          onClick={() => {
            setIsVisible(false);
            setTimeout(onClose, 300);
          }}
          className="ml-2 text-white hover:text-gray-200 transition-colors"
        >
          ×
        </button>
      </div>
    </div>
  );
};

export default ToastNotification;